import Http from '../../http';

class TripServices {
  static async create(data) {
    return Http.post('/trip', data);
  }

  static async getAllTrips() {
    return Http.get('/trip');
  }

  static async getOngoingTrips() {
    return Http.get('/trip/ongoing');
  }

  static async getTrip(id) {
    return Http.get(`/trip/${id}`);
  }

  static async getTripByIdPopulateAllData(id) {
    return Http.get(`/tripdetails/${id}`);
  }


  static async update(id, data) {
    console.log('-------------------------in update', data);
    return Http.update(`/trip/${id}`, data);
  }


  static async getRiderAverageRatingCount(data) {
    console.log('=================================================================i am in the rating http services', data)
    return Http.post('/rating', data);
  }




  static async getLastTrip(userId) {
    return Http.get(`/trip/getLastTrip/${userId}`);
  }

  static async getMostTraveledTrip(userId) {
    return Http.get(`/trip/getMostTraveledTrip/${userId}`);
  }


  static async checKPaymentStatus(merchantTransactionId) {
    console.error('in the checkPaymentStatus==', merchantTransactionId)
    return Http.get(`/checKPaymentStatus/${merchantTransactionId}`);
  }

  static async callBackURL(data) {
    console.log('=====================================CallBack services==========================', data)
    return Http.post('/callbackUrl', data);
  }


  static async updateInvoice(id) {
    console.log('updateInvoice&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-------------------------in update',id);
    return Http.post(`/updateInvoice/${id}`);

    
  }


}

export default TripServices;
